/* eslint-disable */
const CheckInDateRangeObjectValue = Backbone.Model.extend({
	defaults: {
		from: null,
		to: null,
		daysFlexible: 0,
	}
});

export default CheckInDateRangeObjectValue;